module.exports = __webpack_public_path__ + "img/icon-visa-small.4b682b50.svg";